// @ts-nocheck
import React, {Fragment} from "react";
import {CardCvcElement} from "@stripe/react-stripe-js";
import ReactTooltip from "react-tooltip";

export default function CvcField() {
    return (
        <p className={"focus"} style={{position: 'relative'}}>
            <Fragment><span className="tip"
                            data-tip={"Security code usually found on the back of your card"}></span><ReactTooltip/></Fragment>
            {/*<label htmlFor="lpd">CVC</label>*/}
            <label htmlFor={"cc-cvc"}>&nbsp;</label>
            <input type="text" className="cc-cvc" id={"cc-cvc"} readOnly={true}/>
            <div style={{position: 'absolute', top: 24, left: 24, right: 0, zIndex: 10}}>
                <CardCvcElement options={{
                    style: {
                        base: {
                            backgroundColor: "rgba(0,0,0,0)",
                            fontSize: "20px",
                            color: "rgb(47, 47, 47)",
                            '::placeholder': {
                                color: "rgba(47, 47, 47, 0.3)",
                            },
                        },
                    },
                    hidePostalCode: true,
                }}/>
            </div>
        </p>
    )
}
